import React from "react";
import { Bar } from "react-chartjs-2";
import { BarElement, Chart as ChartJS, } from "chart.js";
import { GraphProps } from "../../utils/hooks/types/graphProps";

ChartJS.register(
	BarElement,
);
/**
 *  Loads a bar graph showing the top 3 publications,
 */
export const TopThreeGraph = ({ labels, datasets }: GraphProps, props: any) => {
	return <Bar data={{ labels, datasets }}
		options={{
			responsive: true,
			resizeDelay: 150,
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true
					}
				}]
			},
			animation: {
				duration: 1500,
				easing: "linear"
			},
		}}
		{...props}/>;
};

export default TopThreeGraph;